
import { Input, Space } from 'antd'
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

const LinkForm = (props) => {
    const { values, disabled = false, parent = "", tableLabel = "", multipleLinkAllowed = false } = props
    let currentValue = values?.[props.id]
    const [links, setLinks] = useState([''])

    useEffect(() => {
        if (Array.isArray(currentValue) && currentValue.length > 0) {
            setLinks(currentValue)
        } else {
            setLinks([''])
        }
    }, [values])

    const handleLinkClick = (link) => {
        window.open(link, "_blank")
    }

    // Keep the row value in sync through the shared table handler so the whole
    // table persists as a single array field (avoids nested Form field collision).
    const commitLinks = (nextLinks) => {
        setLinks(nextLinks)
        if (props.handleChange) {
            props.handleChange(props.id, nextLinks, props.documentId)
        }
    }

    const updateLink = (index, value) => {
        commitLinks(links.map((link, i) => (i === index ? value : link)))
    }

    const addLink = () => commitLinks([...links, ''])

    const removeLink = (index) => {
        const nextLinks = links.filter((_, i) => i !== index)
        commitLinks(nextLinks.length > 0 ? nextLinks : [''])
    }

    return (
        <>
            {
                disabled ?
                    <>
                        {
                            links.filter(Boolean).map((link, index) => (
                                <div key={index} className='info-editor-link' onClick={() => handleLinkClick(link)}>{link}</div>
                            ))
                        }
                    </>
                    :
                    <>
                        {links.map((link, index) => (
                            <Space
                                key={index}
                                style={{
                                    display: 'flex',
                                    marginBottom: 8,
                                    alignItems: 'baseline',
                                    minWidth: "200px"
                                }}
                            >
                                <Input value={link} onChange={(e) => updateLink(index, e.target.value)} />
                                {
                                    index === links.length - 1 &&
                                    <PlusOutlined onClick={addLink} />
                                }
                                <MinusCircleOutlined style={{ visibility: links.length > 1 ? "visible" : "hidden" }} onClick={() => removeLink(index)} />
                            </Space>
                        ))}
                    </>
            }
        </>
    )
}

export default LinkForm
